<template>
  <label :class="facetModifier" class="Facet" data-ht-element="filter-value" :data-ht-meta-name="value.label">
    <input type="checkbox" :checked="isSelected" @change="onChange" :value="value.label" />
    <span v-if="isColor" class="swatch" :style="swatchStyling"></span>
    <span class="Facet__Value" :class="textModifier">
      <span>{{ value.label }}</span>
      <span v-if="description" class="p5" data-color="gray-text">
        {{ description }}
      </span>
    </span>
  </label>
</template>

<script setup>
import { ref, computed, onBeforeMount } from 'vue';
import { fetchStorefront } from '@utils/GraphQLClient';
import { FACET_DETAILS_QUERY } from './Composables/Queries';

const emits = defineEmits(['handle-selection']);
const props = defineProps({
  id: String,
  value: Object,
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const description = ref(false);

const selected = computed(() => {
  return props.isSelected ? 'Facet--Selected' : '';
});

const isColor = computed(() => props.id.includes('color'));

const swatchStyling = computed(() => {
  if (!isColor.value) return '';

  const hex = props.value.swatch?.color;
  const image = props.value.swatch?.image;

  if (!hex && !image) return '';

  if (hex) {
    return `background-color: ${hex};`;
  } else {
    return `background-image: url(${image.data.url});`;
  }
});

const facetModifier = computed(() => {
  const isColorFacet = isColor.value ? 'Facet--Color' : '';
  const isSelected = selected.value ? 'Facet--Selected' : '';
  return `${isColorFacet} ${isSelected}`;
});

const textModifier = computed(() => {
  return selected.value ? 't4' : 'p4';
});

const outputtedMetaobjectId = () => {
  const id = props.value.id.split('gid-shopify-metaobject-')[1].trim();
  return `gid://shopify/Metaobject/${id}`;
};

const onChange = () => {
  const data = {};
  data[props.id] = isColor.value ? outputtedMetaobjectId() : props.value.label;
  data.applied = !props.isSelected;
  emits('handle-selection', data);
};

const fetchFacetDescription = async () => {
  const handle = props.value.label.replace(/\s+/g, '-').toLowerCase();

  const request = {
    query: FACET_DETAILS_QUERY,
    variables: {
      handle: handle,
      type: 'facet_details',
    },
  };

  try {
    const response = await fetchStorefront(request);
    const fields = response.data.metaobject.fields;
    const value = fields.find((field) => field.key === 'description').value;
    return value;
  } catch {
    return false;
  }
};

onBeforeMount(async () => {
  description.value = await fetchFacetDescription();
});
</script>
